var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#272C36",
    fillOpacity: 0.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 30.67C24.81 30.67 24.62 30.6 24.47 30.45L17.95 23.93C16.89 22.87 16.89 21.13 17.95 20.07L24.47 13.55C24.76 13.26 25.24 13.26 25.53 13.55C25.82 13.84 25.82 14.32 25.53 14.61L19.01 21.13C18.53 21.61 18.53 22.39 19.01 22.87L25.53 29.39C25.82 29.68 25.82 30.16 25.53 30.45C25.38 30.59 25.19 30.67 25 30.67Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left-arrow-icon.aa4b473d44ce7e0dad6ea30779967795.svg";
export { ForwardRef as ReactComponent };